module.exports = __webpack_public_path__ + "img/rarity1.375b534d.png";